import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { DatePickerType } from '@shared/types/date-picker-type';
import { DateRangePresetOption } from '@shared/models/date-range-preset-option';
import { DatetimePresentation } from '@ionic/core';
import moment from 'moment';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class DatePickerComponent implements OnInit, OnDestroy, OnChanges {
  @Input() datePickerType: DatePickerType = 'default';
  @Input() fromDate: string;
  @Input() date: string;
  @Input() toDate: string;
  @Input() minDate: string;
  @Input() maxDate: string;
  @Input() autoSelectCustomDate: boolean = false;
  @Input() datePickerId: string = 'date-picker';
  @Input() removableDate: boolean = false;
  @Input() presentationType: DatetimePresentation;
  @Input() presetOptions: DateRangePresetOption[] = [];
  @Input() showPopover: boolean = false;
  @Input() focused: boolean = false;
  @Input() disabled: boolean = false;
  @Output() selectedDates = new EventEmitter<{
    fromDate?: string;
    toDate?: string;
    date?: string;
  }>();
  selectedFromDate: string | undefined;
  selectedDate: string | undefined;
  selectedToDate: string | undefined;
  selectedPreset: DateRangePresetOption;
  customDateActive: boolean = false;
  isOpen: boolean = false;

  ngOnInit(): void {
    this.selectedPreset = this.presetOptions.find((preset) => preset.default) || this.presetOptions[0];
    this.selectedFromDate = this.fromDate || undefined;
    this.selectedDate = this.date || undefined;
    this.selectedToDate = this.toDate || undefined;
    this.presentationType = this.presentationType || 'date';
    this.isOpen = false;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['showPopover']) this.isOpen = true;
  }

  ngOnDestroy(): void {
    document.getElementById(`date-popover-${this.datePickerId}`)?.remove();
    document.getElementById(`to-date-popover-${this.datePickerId}`)?.remove();
    document.getElementById(`from-date-popover-${this.datePickerId}`)?.remove();
  }

  selectFromDate(event: any) {
    this.selectedFromDate = event;
    this.customDateActive = true;
    if (this.autoSelectCustomDate || window.innerWidth < 768) {
      this.emitDateSelection();
    }
    this.focused = true;
  }

  selectDate(event: any) {
    this.selectedDate = event;
    this.customDateActive = false;
    this.emitDateSelection();
  }

  selectToDate(event: any) {
    this.selectedToDate = event;
    this.customDateActive = true;
    this.focused = true;
    if (this.autoSelectCustomDate || window.innerWidth < 768) {
      this.emitDateSelection();
    }
  }

  emitDateSelection() {
    this.selectedDates.emit({
      fromDate:
        this.presentationType == 'month-year'
          ? moment(this.selectedFromDate).startOf('month').toISOString(true)
          : this.selectedFromDate,
      toDate:
        this.presentationType == 'month-year'
          ? moment(this.selectedToDate).endOf('month').toISOString(true)
          : this.selectedToDate,
      date: this.selectedDate,
    });
    this.focused = false;
  }

  selectPreset(preset: DateRangePresetOption) {
    this.selectedPreset = preset;
    this.selectedFromDate = preset.fromDate;
    this.selectedToDate = preset.toDate;
    this.customDateActive = false;
    this.emitDateSelection();
  }

  presetEvent(event: any) {
    if (!!event.detail.value) {
      this.selectPreset(event.detail.value);
    }
  }

  removeDate() {
    this.selectedDate = undefined;
    this.emitDateSelection();
  }
}
